var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconEnvelope = function SvgIconEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.174 7.447-.827.563-10.485 7.144a2.426 2.426 0 0 1-1.363.428c-.47 0-.94-.143-1.359-.426l-.007-.005-10.48-7.254-.826-.572L0 6.753V24.49h27V6.885l-.826.562Z",
    fill: "#949191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.331 5.51 1.327.918 1.327.918 9.018 6.242c.308.207.69.206.997-.002l9.158-6.24 1.348-.918 1.347-.918H1.331Z",
    fill: "#949191"
  })));
};

export default SvgIconEnvelope;